
export default {
  data() {
    return {
        items: [
        ]
    }
  },
  props: {
   
  },
  methods: {
    changeSelection(e, val) {      
          let target = this.$refs[`et${val}`].$el          
          this.$emit('changeSelection', {target, value: e })
        
    },
  },
};
